// extracted by mini-css-extract-plugin
module.exports = {"text":"notification_message-module__text--2BkC-","border":"notification_message-module__border--2v2Qh"};